export const isLogin = () => {
  return localStorage.getItem('user_session') !== null;
};